// extracted by mini-css-extract-plugin
module.exports = {"modalwrapper":"_1Pxcu","modalHeader":"_2kaA0","backIcon":"_8eZrB","headerPrice":"_2D9o_","taskWrapper":"_3RBnT","title":"_1OWhf","noteWrapper":"otuZu"};